import { render, staticRenderFns } from "./EventShowCard.vue?vue&type=template&id=3d3dc62b"
import script from "./EventShowCard.vue?vue&type=script&lang=ts"
export * from "./EventShowCard.vue?vue&type=script&lang=ts"
import style0 from "./EventShowCard.vue?vue&type=style&index=0&id=3d3dc62b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports